<template>
  <!-- Page Content -->
  <div class="no_nav_height">
    <div class="row f-row justify-content-center">
      <!-- Row: title -->
      <div class="row f-row mb-1 markets-chart-title d-flex align-items-center">
        <div class="col col-6 container-comp-title">
          <span style="color: var(--textactive)" v-if="isCurrency">
            {{ currencyString.currency_name.slice(0, 3) }}/{{
              currencyString.currency_name.slice(3, 6)
            }}
          </span>
          <span style="color: var(--textactive)" v-else>
            {{ commodityStringLong }}
          </span>
          vs.
          <span style="color: var(--textactive)">
            {{ comparedAssetLong }}
          </span>
          Comparison
        </div>
        <slot name="spot"></slot>
      </div>
      <!-- Row: controls and labels -->
      <div class="controls-labels row f-row txt-label-primary-2">
        <div class="col col-auto txt-label-primary-2 text-left">
          <span class="mr-2">Asset Type:</span>
        </div>
        <div class="col col-1 text-left" style="z-index: 1000!important;">
          <Dropdown
            v-model="selectedAssetType"
            :options="assetTypes"
            @change="onSelectedAssetType"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Asset"
            scrollHeight="400px"
          >
            <template #value="slotProps">
              {{ assetTypes[slotProps.value].asset }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="col col-auto txt-label-primary-2 text-center">
          <span class="ml-3 mr-2">Asset:</span>
        </div>
        <div
          class="col col-1 text-left"
          style="z-index: 1000!important;"
          v-show="selectedAssetType === 0"
        >
          <Dropdown
            v-model="selectedAsset0"
            :options="
              currencySpecs.map((d, i) => {
                return { asset: d.currency_name, id: i };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Currency"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ currencySpecs[slotProps.value].currency_name.toUpperCase() }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-1 ml-1 mr-1 text-left"
          style="z-index: 1000!important;"
          v-show="selectedAssetType === 1"
        >
          <span v-if="showLoadingComm" class="text-right">
            <QSLoading
              :isLoading="showLoadingComm"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset1"
            :options="
              commoditySpecs.map((d, i) => {
                return { asset: d.fk_idproduct.toUpperCase(), id: i };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Commodity"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ commoditySpecs[slotProps.value].fk_idproduct.toUpperCase() }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-1 ml-1 mr-1 text-left"
          style="z-index: 1000!important;"
          v-show="selectedAssetType === 2"
        >
          <span v-if="showLoadingIR" class="text-right">
            <QSLoading
              :isLoading="showLoadingIR"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset2"
            :options="
              irSpecs.map((d, i) => {
                return {
                  asset: d.interest_rate_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Interest Rate"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ irSpecs[slotProps.value].interest_rate_name }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          v-show="selectedAssetType === 2"
          class="col col-auto txt-label-primary-2 text-center"
        >
          <span class="ml-3 mr-2">Term:</span>
        </div>
        <div
          class="h-100 txt-label-primary-2"
          style="width: 27px;"
          v-show="selectedAssetType === 2"
        >
          <HoverMultiSelection
            :btnWidth="'2.5rem'"
            :options="irAvailableTerms"
            :selected="irSelectedTerm"
            @eventOnChangeOption="(opt) => onChangeTerm(opt.value)"
          />
        </div>
        <div
          class="col col-1 ml-1 mr-1 text-left"
          style="z-index: 1000!important;"
          v-show="selectedAssetType === 3"
        >
          <span v-if="showLoadingInd" class="text-right">
            <QSLoading
              :isLoading="showLoadingInd"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset3"
            :options="
              indexSpecs.map((d, i) => {
                return {
                  asset: d.short_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Index"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ indexSpecs[slotProps.value].short_name }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-1 ml-1 mr-1 text-left"
          style="z-index: 1000!important;"
          v-show="selectedAssetType === 4"
        >
          <span v-if="showLoadingFut" class="text-right">
            <QSLoading
              :isLoading="showLoadingFut"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset4"
            :options="
              futuresSpecs.map((d, i) => {
                return {
                  asset: d.short_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Future"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ futuresSpecs[slotProps.value].short_name }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div
          class="col col-1 ml-1 mr-1 text-left"
          style="z-index: 1000!important;"
          v-show="selectedAssetType === 5"
        >
          <span v-if="showLoadingETF" class="text-right">
            <QSLoading
              :isLoading="showLoadingETF"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
          <Dropdown
            v-model="selectedAsset5"
            :options="
              etfSpecs.map((d, i) => {
                return {
                  asset: d.short_name.toUpperCase(),
                  id: i,
                };
              })
            "
            @change="onUserAssetSelection"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select ETF"
            scrollHeight="400px"
            :filter="true"
          >
            <template #value="slotProps">
              {{ etfSpecs[slotProps.value].short_name }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="col col-auto txt-label-primary-2 text-center">
          <span class="ml-3 mr-2">Method:</span>
        </div>
        <div class="col col-1 text-left" style="z-index: 1000!important;">
          <Dropdown
            v-model="selectedMethod"
            :options="operationTypes"
            @change="onPickedComparison"
            optionLabel="asset"
            optionValue="id"
            placeholder="Select Visualization"
            scrollHeight="400px"
          >
            <template #value="slotProps">
              {{ operationTypes[slotProps.value].asset }}
            </template>
            <template #option="slotProps">
              <div class="country-item">
                <div>{{ slotProps.option.asset }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="col col-auto txt-label-primary-2 text-center">
          <span class="ml-3 mr-2">Multiply:</span>
        </div>
        <div style="width: 48px!important;">
          <InputNumber
            style="height: 25px!important;"
            :tableFormat="false"
            :value="multiply"
            @input="(val) => onUserMultiply(val)"
          />
        </div>
        <div
          class="h-100 txt-label-primary-2 text-left container-conversion"
          style="width: 25px; padding-left: 5px!important;"
          v-show="selectedAssetType === 1"
        >
          <Dropdown
            v-model="optionConv"
            :options="
              commodityConversions.map((d) => {
                return {
                  asset: `${d.text}: ${d.value}`,
                  id: d.id,
                };
              })
            "
            @change="onChangeConversion"
            optionLabel="asset"
            optionValue="asset"
            scrollHeight="400px"
            :filter="true"
          >
            <template #indicator>
              <i class="fa fa-mouse-pointer mouse-pointer"></i>
            </template>
            <template #value="slotProps">
              {{ slotProps.value }}
            </template>
            <template #option="slotProps">
              <div>{{ slotProps.option.asset }}</div>
            </template>
          </Dropdown>
        </div>
        <div class="col col-auto txt-label-primary-2 text-center">
          <span class="ml-3 mr-2">Range:</span>
        </div>
        <div class="h-100 txt-label-primary-2" style="width: 27px;">
          <HoverMultiSelection
            :btnWidth="'2.5rem'"
            :options="[
              { label: '1M', value: '1M' },
              { label: '3M', value: '3M' },
              { label: '6M', value: '6M' },
              { label: '1Y', value: '1Y' },
              { label: '2Y', value: '2Y' },
              { label: '3Y', value: '3Y' },
              { label: '5Y', value: '5Y' },
              { label: '10Y', value: '10Y' },
              { label: '20Y', value: '20Y' },
            ]"
            :selected="pickedDateInterval"
            @eventOnChangeOption="(opt) => onChangeInterval(opt.value)"
          />
        </div>
        <div
          class="col col-auto txt-label-primary-2"
          style="margin-right: 0.5rem!important;"
        >
          <span class="ml-3 mr-2">Resize:</span>
          <div class="inh">
            <button
              class="inh"
              @click="onRestoreSizes"
              style="font-size: 1.3rem; padding-right: 8px!important;"
            >
              <i class="fa fa-arrows-alt" title="Restore chart sizes"></i>
            </button>
          </div>
        </div>
        <div
          class="col col-cx txt-label-primary-2 text-center comparison-container"
          style="background: var(--background); border: 1px solid var(--lightbackground)"
        >
          <!-- Fetch Data Button -->
          <div
            v-if="showFetch"
            class="fetch-overlay"
            @click.self="getComparisonData"
          >
            <button
              v-if="showFetch"
              type="button"
              :disabled="!showFetch"
              class="btn btn-strat-alert"
              style="margin: 0!important; width: 100px!important; min-width: 100px!important; height: 2rem !important;"
              v-on:click="getComparisonData"
            >
              <span
                v-if="showLoading || showLoadingDataPrep"
                class="text-center"
              >
                <QSLoading
                  :isLoading="showLoading || showLoadingDataPrep"
                  :size="20"
                  :colorTheme="true"
                />
              </span>
              <span v-else>Fetch</span>
            </button>
          </div>
          <table
            class="table table-sm table-borderless table-data-controls"
            style="width: 100%;"
          >
            <tr class="txt-label-primary-5">
              <td
                class="txt-label-primary-5 text-truncate"
                style="width: 18.75%"
              >
                {{ !showFetch ? dateTitle : "-" }}
              </td>
              <td
                class="txt-label-primary-5 text-truncate"
                style="width: 18.75%"
              >
                <span v-if="isCurrency">
                  {{ currencyString.currency_name.slice(0, 3) }}/{{
                    currencyString.currency_name.slice(3, 6)
                  }}:
                </span>
                <span v-else class="text-truncate">{{ commodityString }}:</span>
              </td>
              <td
                class="txt-label-primary-5 text-truncate"
                style="width: 18.75%"
              >
                {{ comparedAsset }}:
              </td>
              <td
                class="txt-label-primary-5 text-truncate"
                style="width: 18.75%"
              >
                Spread:
              </td>
              <td
                class="txt-label-primary-5 text-truncate"
                style="width: 18.75%"
              >
                Correlation:
              </td>
            </tr>
            <tr>
              <td class="txt-label-primary" style="width: 25%">
                <div id="compDate" class="candle-hover-info text-center">
                  -
                </div>
              </td>
              <td class="txt-label-primary" style="width: 18.75%;">
                <div
                  id="compMain"
                  class="candle-hover-info text-center"
                  style="color: var(--symmetry-h)!important;"
                >
                  -
                </div>
              </td>
              <td class="txt-label-primary" style="width: 18.75%;">
                <div
                  id="compSecond"
                  class="candle-hover-info  text-center"
                  style="color: var(--hedge-h)!important;"
                >
                  -
                </div>
              </td>
              <td class="txt-label-primary" style="width: 18.75%">
                <div id="compSpread" class="candle-hover-info  text-center">
                  -
                </div>
              </td>
              <td class="txt-label-primary" style="width: 18.75%">
                <div id="compCorr" class="candle-hover-info  text-center">
                  -
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- Charts -->
      <div class="row f-row container_charts comparison-container">
        <div v-if="showFetch" class="fetch-overlay"></div>
        <Splitter class="col" layout="vertical" @onContext="onContext">
          <!-- Chart container 1 -->
          <SplitterPanel
            class="row f-row prices_height"
            :size="chartSizes.sizeSplitterChartPrices"
            :minSize="4"
            :style="`flex-basis: ${chartSizes.sizeSplitterChartPrices};`"
          >
            <!-- Chart 1 -->
            <div class="container-chart-comp">
              <!-- Row: legend -->
              <div
                class="row f-row container-legends-comp"
                style="top: 15px!important;"
              >
                <div class="col col-auto text-left" style="z-index: 999;">
                  <table
                    class="table table-sm table-responsive table-borderless table-market-legend"
                    style="width: 100%; background: rgba(0,0,0,0)"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="text-left"
                          v-if="
                            selectedMethod <= 2 ||
                              selectedMethod === 4 ||
                              selectedMethod === 7
                          "
                        >
                          <i class="fa fa-minus mr-1" style="color:var(--expo)">
                          </i>
                          <span v-if="isCurrency" class="active-txt">
                            {{ currencyString.currency_name.slice(0, 3) }}/{{
                              currencyString.currency_name.slice(3, 6)
                            }}
                          </span>
                          <span v-else class="active-txt">{{
                            commodityString
                          }}</span>
                          <span v-if="isTwoAxes === true"> (left)</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod <= 2">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--hedge)"
                          >
                          </i>
                          <span class="active-txt"> {{ comparedAsset }}</span>
                          <span v-if="isTwoAxes === true"> (right)</span>
                        </td>
                        <td
                          class="text-left"
                          v-if="selectedMethod === 3 || selectedMethod === 8"
                        >
                          <i class="fa fa-minus mr-1" style="color:var(--expo)">
                          </i>
                          log
                          <span v-if="isCurrency" class="active-txt">
                            {{ currencyString.currency_name.slice(0, 3) }}/{{
                              currencyString.currency_name.slice(3, 6)
                            }}
                          </span>
                          <span v-else class="active-txt">{{
                            commodityString
                          }}</span>
                          <span v-if="isTwoAxes === true"> (left)</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 3">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--hedge)"
                          >
                          </i>
                          log
                          <span class="active-txt">{{ comparedAsset }}</span>
                          <span v-if="isTwoAxes === true"> (right)</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 4">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--hedge)"
                          >
                          </i>
                          <span class="active-txt"
                            >{{ comparedAsset }} inverse axis</span
                          >
                          <span v-if="isTwoAxes === true"> (right)</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 5">
                          <i class="fa fa-minus mr-1" style="color:var(--expo)">
                          </i>
                          <span v-if="isCurrency" class="active-txt">
                            {{ currencyString.currency_name.slice(0, 3) }}/{{
                              currencyString.currency_name.slice(3, 6)
                            }}
                          </span>
                          <span v-else class="active-txt">{{
                            commodityString
                          }}</span>
                          &times;
                          <span class="active-txt">{{ comparedAsset }}</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 6">
                          <i class="fa fa-minus mr-1" style="color:var(--expo)">
                          </i>
                          <span v-if="isCurrency" class="active-txt">
                            {{ currencyString.currency_name.slice(0, 3) }}/{{
                              currencyString.currency_name.slice(3, 6)
                            }}
                          </span>
                          <span v-else class="active-txt">{{
                            commodityString
                          }}</span>
                          /
                          <span class="active-txt">{{ comparedAsset }}</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 7">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--hedge)"
                          >
                          </i>
                          Regression:
                          <span v-if="filteredData[0].b < 0" class="active-txt"
                            >&#8722;</span
                          >
                          <span v-else class="active-txt">&#43;</span>
                          <span class="active-txt">{{
                            Math.abs(filteredData[0].b) | priceFormat
                          }}</span>
                          <span v-if="filteredData[0].m >= 0" class="active-txt"
                            >>&#43;</span
                          >
                          <span v-else class="active-txt">&#8722;</span>
                          <span class="active-txt">{{
                            Math.abs(filteredData[0].m) | priceFormat
                          }}</span>
                          &times;
                          <span class="active-txt">{{ comparedAsset }}</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 8">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--hedge)"
                          >
                          </i>
                          Regression:
                          <span
                            v-if="filteredData[0].lnB < 0"
                            class="active-txt"
                            >&#8722;</span
                          >
                          <span v-else class="active-txt">&#43;</span>
                          <span class="active-txt">{{
                            Math.abs(filteredData[0].lnB) | priceFormat
                          }}</span>
                          <span
                            v-if="filteredData[0].lnM >= 0"
                            class="active-txt"
                            >&#43;</span
                          >
                          <span v-else class="active-txt">&#8722;</span>
                          <span class="active-txt">{{
                            Math.abs(filteredData[0].lnM) | priceFormat
                          }}</span>
                          &times; log
                          <span class="active-txt">{{ comparedAsset }}</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 9">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--expo)"
                          ></i>
                          <span v-if="isCurrency" class="active-txt">
                            {{ currencyString.currency_name.slice(0, 3) }}/{{
                              currencyString.currency_name.slice(3, 6)
                            }}
                          </span>
                          <span v-else class="active-txt">{{
                            commodityString
                          }}</span>
                          &#8722;
                          <span class="active-txt">{{ comparedAsset }}</span>
                        </td>
                        <td class="text-left" v-if="selectedMethod === 10">
                          <i
                            class="fa fa-minus mr-1"
                            style="color:var(--expo)"
                          ></i>
                          log(<span v-if="isCurrency" class="active-txt">
                            {{ currencyString.currency_name.slice(0, 3) }}/{{
                              currencyString.currency_name.slice(3, 6)
                            }}
                          </span>
                          <span v-else class="active-txt">{{
                            commodityString
                          }}</span>
                          >) &#8722; log(<span class="active-txt">{{
                            comparedAsset
                          }}</span
                          >)
                        </td>
                        <td>
                          Date range:
                          <span class="active-txt">
                            {{ chartInitDate | dateFormat }} &#x2192;
                            {{ chartEndDate | dateFormat }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Row: Chart -->
              <div class="row f-row h-100">
                <div
                  class="col col-12 text-center progress-div"
                  style="top: 50%;"
                  v-if="showLoading || showLoadingDataPrep"
                >
                  <QSLoading
                    :isLoading="showLoading || showLoadingDataPrep"
                    :size="35"
                    :colorTheme="colorTheme"
                  />
                </div>
                <div
                  class="col col-12 text-center"
                  v-else-if="chartDataRaw.length === 0"
                  style="position: absolute; left: 0; top: 27.5%; z-index: 10000000;"
                >
                  No Data Available
                </div>
                <div class="col col-12 h-100">
                  <div class="col col-12" style="height:100%; width:100%">
                    <div
                      class="h-100 d-flex flex-column"
                      id="comparison_chart-div"
                      style="width: 100%;"
                    >
                      <svg id="svg-comparison"></svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SplitterPanel>
          <SplitterGutter
            :index="0"
            :_this="context"
            @resizestart="onResizePanel"
            @onResize="onResizePanel"
            @resizeend="onResizePanel"
          ></SplitterGutter>
          <!-- Chart container 2 -->
          <SplitterPanel
            class="row f-row"
            :class="getClassChartQty()"
            :size="chartSizes.sizeSplitterChart"
            :minSize="4"
            :style="`flex-basis: ${chartSizes.sizeSplitterChart}%`"
          >
            <!-- Chart 2 -->
            <div class="container-chart-comp">
              <!-- Row: legend -->
              <div class="row f-row container-legends-comp">
                <div class="col col-auto text-left" style="z-index: 999;">
                  <table
                    class="table table-sm table-responsive table-borderless table-market-legend"
                    style="background: rgba(0,0,0,0)"
                  >
                    <tbody>
                      <tr>
                        <td class="text-left">
                          <i class="fa fa-minus" style="color: var(--expo)"></i>
                          Spread:
                          <span v-if="isLn">
                            log
                            <span v-if="isCurrency" class="active-txt">
                              {{ currencyString.currency_name.slice(0, 3) }}/{{
                                currencyString.currency_name.slice(3, 6)
                              }}
                            </span>
                            <span v-else class="active-txt">{{
                              commodityString
                            }}</span>
                            - log
                            <span class="active-txt">{{ comparedAsset }}</span>
                          </span>
                          <span v-else>
                            <span v-if="isCurrency" class="active-txt">
                              {{ currencyString.currency_name.slice(0, 3) }}/{{
                                currencyString.currency_name.slice(3, 6)
                              }}
                            </span>
                            <span v-else class="active-txt">{{
                              commodityString
                            }}</span>
                            &#8722;
                            <span class="active-txt">{{ comparedAsset }}</span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Row: Chart -->
              <div class="row f-row h-100">
                <div
                  class="col col-12 text-center progress-div"
                  style="top: 50%;"
                  v-if="showLoading || showLoadingDataPrep"
                >
                  <QSLoading
                    :isLoading="showLoading || showLoadingDataPrep"
                    :size="35"
                    :colorTheme="colorTheme"
                  />
                </div>
                <div
                  class="col col-12 text-center"
                  v-else-if="chartDataRaw.length === 0"
                  style="position: absolute; left: 0; top: 82.5%; z-index: 10000000;"
                >
                  No Data Available
                </div>
                <div class="col col-12" style="height:100%; width:100%">
                  <div
                    class="h-100 d-flex flex-column"
                    id="spread-div"
                    style="width: 100%; "
                  >
                    <svg id="svg-spread"></svg>
                  </div>
                </div>
              </div>
            </div>
          </SplitterPanel>
          <SplitterGutter
            :index="1"
            :_this="context"
            @resizestart="onResizePanel"
            @onResize="onResizePanel"
            @resizeend="onResizePanel"
            :eventElement="newEventElement"
            :eventParentElement="eventParentElement"
          ></SplitterGutter>
          <!-- Chart container 3 -->
          <SplitterPanel
            class="row f-row table_height"
            :size="chartSizes.sizeSplitterChartCorr"
            :minSize="4"
            :style="`flex-basis: ${chartSizes.sizeSplitterChartCorr}%`"
          >
            <!-- Chart 3 -->
            <div class="container-chart-comp">
              <!-- Row: legend -->
              <div class="row f-row container-legends-comp">
                <div class="col col-auto text-left" style="z-index: 999;">
                  <table
                    class="table table-sm table-responsive table-borderless table-market-legend"
                    style="background: rgba(0,0,0,0)"
                  >
                    <tbody>
                      <tr>
                        <td class="text-left">
                          <i class="fa fa-minus" style="color: var(--expo)"></i>
                          <span class="inline-ul ml-1">
                            <label>
                              <input
                                v-model.number.lazy="nCorrel"
                                @change="onUserNCorrelChange"
                                placeholder="20"
                                class="custom-input-3"
                              />
                            </label>
                            Day rolling return correlation
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Row: Chart -->
              <div class="row f-row h-100">
                <div
                  class="col col-12 text-center progress-div"
                  style="top: 50%;"
                  v-if="showLoading || showLoadingDataPrep"
                >
                  <QSLoading
                    :isLoading="showLoading || showLoadingDataPrep"
                    :size="35"
                    :colorTheme="colorTheme"
                  />
                </div>
                <div
                  class="col col-12 text-center"
                  v-else-if="chartDataRaw.length === 0"
                  style="position: absolute; left: 0; top: 77.5%; z-index: 10000000;"
                >
                  No Data Available
                </div>
                <div class="col col-12" style="height:100%; width:100%">
                  <div
                    class="h-100 d-flex flex-column"
                    id="correl-div"
                    style="width: 100%; "
                  >
                    <svg id="svg-correl"></svg>
                  </div>
                </div>
              </div>
            </div>
          </SplitterPanel>
        </Splitter>
      </div>
    </div>
  </div>
</template>

<script>
import { zoomIdentity, format, select } from "d3";
import Dropdown from "primevue/dropdown";
import InputNumber from "@/components/InputNumber";
import {
  assetTypesConst,
  COMPARISON_TYPE_SLUGS,
  colorExpo,
  colorExpoAlpha,
  colorHedge,
  colorHedgeH,
  colorSymmetryH,
  commoditySpecsConst,
  currencyFormat,
  currencySpecsConst,
  dateFormat,
  etfSpecsConst,
  futuresSpecsConst,
  indexSpecsConst,
  irSpecsConst,
  operationTypesConst,
  prefixOptions,
  tFormat,
  titleTexts,
} from "@/_core/_helpers/_parametric_tools";
import {
  regression,
  rollingCorrelation,
} from "@/_core/_helpers/_quadraticVolatility";
import { additionalYSpace, lengthByDate } from "@/_core/_helpers/_helpers";
import { ComparisonCorrelHover } from "@/_core/charts/ComparisonCorrel";
import { ComparisonHover } from "@/_core/charts/Comparison";
import { ComparisonSpreadHover } from "@/_core/charts/ComparisonSpread";
import { D3Chart } from "@/_core/charts/D3Chart";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { getConversions } from "@/_core/data/Markets";
import { inRange } from "@/_core/charts/TechnicalAnalysis";
import moment from "moment";
import Splitter from "../splitter/Splitter.vue";
import SplitterGutter from "../splitter/SplitterGutter.vue";
import SplitterPanel from "../splitter/SplitterPanel.vue";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import QSLoading from "@/components/QSLoading.vue";
import { slugifyProductItem } from "@/components/markets/marketsRouteSync";

export default {
  name: "Comparison",
  props: {
    chartDataRaw: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    commodityString: { required: false, default: "N.A" },
    commodityStringLong: { required: false, default: "N.A" },
    currencyString: { required: true, default: () => [] },
    dataReady: { required: true },
    isCurrency: { required: true, type: Boolean, default: true },
    processData: { required: true },
    showLoadingParent: { required: true },
    eventElement: { required: false, default: () => PointerEvent },
    render: { required: true, default: false },
    initCompareType: { required: false, default: null },
    initCompareAsset: { required: false, default: null },
  },
  components: {
    QSLoading,
    Dropdown,
    HoverMultiSelection,
    InputNumber,
    Splitter,
    SplitterPanel,
    SplitterGutter,
  },
  data() {
    return {
      additionalDates: [],
      lastCommittedType: null,
      lastCommittedAsset: null,
      assetTypes: assetTypesConst,
      chartBodyTA: [],
      chartSizes: {
        sizeSplitterChartPrices: 61,
        sizeSplitterChart: 19,
        sizeSplitterChartCorr: 19,
      },
      context: {},
      commodityConversions: [{ id: 0, text: "...", value: 1 }],
      commoditySpecs: commoditySpecsConst,
      comparedAsset: "N.A",
      comparedAssetLong: "N.A",
      conversionByCmdty: {},
      currencyFormat: currencyFormat,
      currencyNumber: 1,
      currencySpecs: currencySpecsConst,
      D3Chart: null,
      D3ChartCorrel: null,
      D3ChartSpread: null,
      dateFormat: dateFormat,
      dateTitle: "Date:",
      etfSpecs: etfSpecsConst,
      externalZoom: false,
      fieldUp: "close",
      fieldUp2: "close2",
      filteredData: [{ b: 0, m: 0 }],
      futuresSpecs: futuresSpecsConst,
      histAsset: [],
      indexSpecs: indexSpecsConst,
      initCommodityDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      inputDataByDate: null,
      interval: "day",
      irAvailableTerms: [],
      irHistAllTerms: [],
      irSelectedTerm: "3M",
      irSpecs: irSpecsConst,
      keepDateInterval: true,
      keysInputDataByDate: null,
      logo: require("@/assets/images/symbol_blue.svg"),
      multiply: 1,
      newEventElement: PointerEvent,
      eventParentElement: null,
      nCorrel: 60,
      operationTypes: operationTypesConst,
      optionConv: "",
      onChangeScenarios: false,
      panels: [],
      pickedDateInterval: "3Y",
      prefixOptions: prefixOptions,
      selectedAsset0: 3,
      selectedAsset1: 3,
      selectedAsset2: 3,
      selectedAsset3: 9,
      selectedAsset4: 7,
      selectedAsset5: 4,
      selectedAssetType: 0,
      selectedMethod: 2,
      showFetch: false,
      showLoading: false,
      showLoadingComm: false,
      showLoadingDataPrep: false,
      showLoadingETF: false,
      showLoadingFut: false,
      showLoadingInd: false,
      showLoadingIR: false,
      spreadFieldName: "spread",
      svgNode: null,
      svgNodeCorrel: null,
      svgNodeSpread: null,
      tFormat: tFormat,
      title: "DAILY",
      titleTexts: titleTexts,
      transform: null,
      xt: null,
      zoomCorrel: null,
      zoomSpread: null,
      zoomTA: null,
    };
  },
  created() {
    let _this = this;
    this.additionalDates = this.processData.createNDays(new Date(), 40);
    // ===== create initial charts instances =====
    this.D3Chart = new D3Chart("comparison_chart-div", "svg-comparison");
    this.D3ChartSpread = new D3Chart("spread-div", "svg-spread");
    this.D3ChartCorrel = new D3Chart("correl-div", "svg-correl");
    // this.D3HoverComparison = new D3HoverComparison();
    // ===== get data specs by asset =====
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.commoditySpecs = this.$store.state.commodities.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.irSpecs = this.$store.state.intRates.all.items;
    } catch (error) {
      console.error(`Error interest rates ${error}`);
    }
    try {
      this.etfSpecs = this.$store.state.etfs.all.items;
    } catch (error) {
      console.error(`Error etfs ${error}`);
    }
    try {
      this.indexSpecs = this.$store.state.indexes.all.items;
    } catch (error) {
      console.error(`Error indexes ${error}`);
    }
    try {
      this.futuresSpecs = this.$store.state.futures.all.items;
    } catch (error) {
      console.error(`Error futures ${error}`);
    }
    this.applyInitialComparison();
    this.onSelectedAssetType();
    this.commodityConversions = getConversions();
    this.conversionByCmdty = {};
    this.commodityConversions.forEach(function(d) {
      _this.conversionByCmdty[d.text + ": " + d.value] = d.value;
    });
  },
  mounted() {
    let _this = this;
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
    this.getComparisonData();
  },
  watch: {
    compareRouteKey() {
      if (
        this.initCompareType === this.lastCommittedType &&
        this.initCompareAsset === this.lastCommittedAsset
      ) {
        return;
      }
      if (!this.initCompareType) return;
      this.applyInitialComparison();
      this.getComparisonData();
    },
    colorTheme() {
      this.callWidth();
    },
    showLoadingParent(val) {
      this.multiply = 1;
      this.showLoading = val;
    },
    showLoading(val) {
      if (val === false) {
        if (this.histAsset.length > 0 && this.chartDataRaw.length > 0) {
          this.dataAndCharts();
          this.showLoadingDataPrep = false;
        }
      }
    },
    histAsset(val) {
      if (val.length > 0 && this.chartDataRaw.length > 0) {
        this.showLoadingDataPrep = true;
        this.dataAndCharts();
        this.showLoadingDataPrep = false;
      }
    },
    dataReady() {
      if (this.histAsset.length > 0) {
        this.showLoadingDataPrep = true;
        this.dataAndCharts();
        this.showLoadingDataPrep = false;
      }
    },
    eventElement(newEvent) {
      const containerChartQty = select(".quantity-xl_height");
      const parentNode =
        containerChartQty.node() && containerChartQty.node().nextSibling;

      this.newEventElement = newEvent;
      this.eventParentElement = parentNode;
      this.onChangeScenarios = true;
    },
    chartSizes: {
      handler: "handleSplitterSizeChange",
      deep: true,
    },
    renderChartSignal: {
      handler() {
        this.callWidth();
      },
      deep: true,
    },
  },
  computed: {
    compareRouteKey() {
      return `${this.initCompareType}|${this.initCompareAsset}`;
    },
    chartInitDate() {
      if (this.filteredData.length === 0) {
        return new Date();
      } else {
        return this.filteredData[0].date;
      }
    },
    chartEndDate() {
      if (this.filteredData.length === 0) {
        return new Date();
      } else {
        return this.filteredData[this.filteredData.length - 1].date;
      }
    },
    isTwoAxes() {
      return (
        this.selectedMethod === 2 ||
        this.selectedMethod === 3 ||
        this.selectedMethod === 4
      );
    },
    isLn() {
      return this.selectedMethod === 3 || this.selectedMethod === 8;
    },
    renderChartSignal() {
      return this.render;
    },
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
    dateFormat: function(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YY");
      }
    },
  },
  methods: {
    dataAndCharts() {
      this.prepInputData();
      this.mergeData();
      this.addRollingCorrelation();
      this.sliceMethod();
      this.createUpperChart();
      this.createMiddleChart();
      this.createLowerChart();
      this.createHoverFX();
    },
    onUserMultiply(val) {
      this.multiply = +val;
      this.dataAndCharts();
    },
    prepInputData() {
      let _this = this;
      _this.inputDataByDate = {};
      _this.keysInputDataByDate = [];
      this.histAsset.forEach(function(d) {
        _this.inputDataByDate[+d.date] = d.close;
        _this.keysInputDataByDate.push(+d.date);
      });
    },
    mergeData() {
      let _this = this;
      let cl;
      this.chartDataRaw.forEach(function(d, i) {
        cl = _this.inputDataByDate[+d.date] * _this.multiply;
        if (Number.isNaN(cl) || cl == null || cl === 0) {
          _this.keysInputDataByDate.sort((a, b) => {
            return Math.abs(+d.date - a) - Math.abs(+d.date - b);
          });
          cl =
            _this.inputDataByDate[_this.keysInputDataByDate[0]] *
            _this.multiply;
        }
        d.close2 = cl;
        d.lnClose = Math.log(d.close);
        d.lnClose2 = Math.log(cl);
        d.spread = d.close - cl;
        d.lnSpread = d.lnClose - d.lnClose2;
        d.zero = 0;
        if (i === 0) {
          d.ret = 0;
          d.ret2 = 0;
        } else {
          d.ret = d.close / _this.chartDataRaw[i - 1].close - 1;
          d.ret2 = cl / _this.chartDataRaw[i - 1].close2 - 1;
        }
      });
    },
    addRollingCorrelation() {
      this.chartDataRaw = rollingCorrelation(
        this.chartDataRaw,
        "ret",
        "ret2",
        this.nCorrel,
      );
    },
    sliceMethod() {
      this.keepDateInterval = true;
      let selectedDays = lengthByDate(
        this.pickedDateInterval,
        this.chartDataRaw.map((d) => d.date),
      );
      this.filteredData = this.processData.toSlice(
        this.chartDataRaw,
        selectedDays,
      );
      if (!this.filteredData.length) return;
      let init1 = this.filteredData[0].close;
      let init2 = this.filteredData[0].close2;
      this.filteredData.forEach(function(d) {
        d.close_100 = (100 * d.close) / init1;
        d.close2_100 = (100 * d.close2) / init2;
        d.mult = d.close * d.close2;
        d.div = d.close / d.close2;
      });
      this.filteredData = regression(
        this.filteredData,
        "close2",
        "close",
        "reg",
        "m",
        "b",
      );
      this.filteredData = regression(
        this.filteredData,
        "lnClose2",
        "lnClose",
        "lnReg",
        "lnM",
        "lnB",
      );
    },
    sameAxisTwoLines(field1, field2) {
      this.fieldUp = field1;
      this.fieldUp2 = field2;
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorExpo(this.colorTheme),
        2,
        this.fieldUp,
        false,
        0,
        [],
        true,
        "close",
        this.chartBodyTA,
        true,
        "id",
      );
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorHedge(this.colorTheme),
        2,
        this.fieldUp2,
        false,
        0,
        [],
        true,
        "close2",
        this.chartBodyTA,
        true,
        "id",
      );
    },
    twoAxes(field1, field2) {
      this.fieldUp = field1;
      this.fieldUp2 = field2;
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorExpo(this.colorTheme),
        2,
        this.fieldUp,
        false,
        0,
        [],
        true,
        "close",
        this.chartBodyTA,
        true,
        "id",
      );
      this.D3Chart.line2Axis(
        this.svgNode,
        this.filteredData,
        colorHedge(this.colorTheme),
        2,
        this.fieldUp2,
        true,
        "close2",
        this.chartBodyTA,
        true,
        "id",
      );
    },
    single(fieldName) {
      this.fieldUp = fieldName;
      this.fieldUp2 = null;
      this.D3Chart.line(
        this.svgNode,
        this.filteredData,
        colorExpo(this.colorTheme),
        2,
        this.fieldUp,
        false,
        0,
        [],
        true,
        "close",
        this.chartBodyTA,
        true,
        "id",
      );
    },
    createUpperChart(calculate = false) {
      if (this.pickedDateInterval !== "-1") {
        this.selectedDays = lengthByDate(
          this.pickedDateInterval,
          this.chartDataRaw.map((d) => d.date),
        );
        let xMin = this.chartDataRaw[
          this.chartDataRaw.length - this.selectedDays
        ].date;
        let xMax = this.additionalDates[this.additionalDates.length - 1].date;
        let data = this.chartDataRaw.map((d) => d);
        this.filteredData = data.filter(function(d) {
          return inRange(d.date, xMin, xMax);
        });
      } else if (calculate) {
        let xt = this.transform.rescaleX(this.svgNode.x);
        let xMin = xt.invert(0);
        let xMax = xt.invert(this.svgNode.width);
        let data = this.chartDataRaw.map((d) => d);
        this.filteredData = data.filter(function(d) {
          return inRange(d.date, xMin, xMax);
        });
        this.selectedDays = this.filteredData.length;
      }

      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.025,
        50,
        0.5,
        65,
        0.5,
        25,
        0.5,
        65,
        this.colorTheme,
        this.logo,
      );
      if (this.svgNode.height === 0 || this.svgNode.width === 0) {
        return;
      }
      // ==== zoom setup
      this.chartBodyTA = this.svgNode
        .append("g")
        .attr("class", "chartBodyTA")
        .attr("clip-path", `url(#clipTA)`);
      this.svgNode
        .append("defs")
        .append("clipPath")
        .attr("id", "clipTA")
        .append("rect")
        .attr("width", this.svgNode.width)
        .attr("height", this.svgNode.height);
      // === minMax
      let minMaxYAxis, minMaxYAxis2;
      minMaxYAxis = this.getMinMaxYAxis();
      minMaxYAxis2 = [minMaxYAxis[2], minMaxYAxis[3]];
      minMaxYAxis = [minMaxYAxis[0], minMaxYAxis[1]];
      // === set axis
      if (
        this.selectedMethod !== 2 &&
        this.selectedMethod !== 3 &&
        this.selectedMethod !== 4
      ) {
        this.svgNode = this.D3Chart.setAxisDateLin(
          this.svgNode,
          this.chartDataRaw
            .map((d) => d.date)
            .concat(this.additionalDates.map((d) => d.date)),
          minMaxYAxis,
          true,
          true,
          false,
          [],
          "zeroLineTA",
          this.chartBodyTA,
        );
      } else {
        this.svgNode
          .append("line")
          .attr("class", "xAxisLine")
          .attr("stroke", "white")
          .attr("x1", 0)
          .attr("y1", 0)
          .attr("x2", this.svgNode.width)
          .attr("y2", 0);
        this.svgNode = this.D3Chart.setDoubleAxisDateLin(
          this.svgNode,
          this.chartDataRaw
            .map((d) => d.date)
            .concat(this.additionalDates.map((d) => d.date)),
          minMaxYAxis,
          minMaxYAxis2,
          colorSymmetryH(this.colorTheme),
          colorHedgeH(this.colorTheme),
          this.selectedMethod === 4,
        );
      }
      // initial transform - zoom
      if (this.pickedDateInterval !== "-1" || calculate) {
        let addLen = this.additionalDates.length;
        let k = this.chartDataRaw.length / (this.selectedDays + addLen);
        let tx =
          ((this.selectedDays + addLen) / this.chartDataRaw.length - 1) *
          this.svgNode.width;
        this.transform = zoomIdentity.scale(k).translate(tx, 0);
        this.xt = this.transform.rescaleX(this.svgNode.x);
        this.bandWidth =
          this.svgNode.x(this.chartDataRaw[1].date) -
          this.svgNode.x(this.chartDataRaw[0].date);
        this.candleWidth = this.bandWidth * this.barWidth + 1;
      }

      // === lines
      if (this.selectedMethod === 0) {
        // SAME AXIS
        this.sameAxisTwoLines("close", "close2");
      } else if (this.selectedMethod === 1) {
        // BASE 100
        this.svgNode["hundredLine"] = this.chartBodyTA
          .append("line")
          .attr("class", "xAxisLine")
          .attr("stroke", "white")
          .attr("x1", 0)
          .attr("y1", this.svgNode.y(100))
          .attr("x2", this.svgNode.width)
          .attr("y2", this.svgNode.y(100));
        this.sameAxisTwoLines("close_100", "close2_100");
      } else if (this.selectedMethod === 2 || this.selectedMethod === 4) {
        // TWO AXES or TWO AXES (INV)
        this.twoAxes("close", "close2");
      } else if (this.selectedMethod === 3) {
        // TWO AXES (LOG)
        this.twoAxes("lnClose", "lnClose2");
      } else if (this.selectedMethod === 5) {
        // TIMES
        this.single("mult");
      } else if (this.selectedMethod === 6) {
        // DIVIDE
        this.single("div");
      } else if (this.selectedMethod === 7) {
        // REGRESS
        this.sameAxisTwoLines("close", "reg");
      } else if (this.selectedMethod === 8) {
        // REGRESS (log)
        this.sameAxisTwoLines("lnClose", "lnReg");
      }
    },
    createMiddleChart() {
      // === set SVG canvas
      this.svgNodeSpread = this.D3ChartSpread.setSVG(
        0.025,
        50,
        0.5,
        65,
        0.5,
        25,
        0.5,
        65,
      );
      // ==== zoom setup
      this.chartBodySpread = this.svgNodeSpread
        .append("g")
        .attr("class", "chartBodySpread")
        .attr("clip-path", `url(#clipSpread)`);
      this.svgNodeSpread
        .append("defs")
        .append("clipPath")
        .attr("id", "clipSpread")
        .append("rect")
        .attr("width", this.svgNodeSpread.width)
        .attr("height", this.svgNodeSpread.height);
      this.spreadFieldName = this.isLn ? "lnSpread" : "spread";
      let minMaxYAxis = this.processData.minMax(
        this.filteredData,
        this.spreadFieldName,
        this.spreadFieldName,
      );
      minMaxYAxis = additionalYSpace(minMaxYAxis, 0.1);
      // === set axis
      this.svgNodeSpread = this.D3ChartSpread.setAxisDateLin(
        this.svgNodeSpread,
        this.chartDataRaw
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis,
        true,
        true,
        false,
        [],
        "zeroLineSpread",
        this.chartBodySpread,
      );
      // === line Area
      this.D3ChartSpread.linesArea(
        this.svgNodeSpread,
        this.filteredData,
        colorExpo(this.colorTheme),
        "rgba(0,0,0,0)",
        2,
        colorExpoAlpha(this.colorTheme),
        this.spreadFieldName,
        "zero",
        false,
        0.5,
        false,
        true,
        "upperLineSpread",
        "lowerLineSpread",
        "areaSpread",
        this.chartBodySpread,
      );
    },
    createLowerChart() {
      // === set SVG canvas
      this.svgNodeCorrel = this.D3ChartCorrel.setSVG(
        0.025,
        50,
        0.5,
        65,
        0.5,
        25,
        0.5,
        65,
      );
      // === set axis
      this.svgNodeCorrel = this.D3ChartCorrel.setAxisDateLin(
        this.svgNodeCorrel,
        this.chartDataRaw
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        [-1, 1],
        true,
        true,
      );
      // ==== zoom setup
      this.chartBodyCorrel = this.svgNodeCorrel
        .append("g")
        .attr("class", "chartBodyCorrel")
        .attr("clip-path", `url(#clipCorrel)`);
      this.svgNodeCorrel
        .append("defs")
        .append("clipPath")
        .attr("id", "clipCorrel")
        .append("rect")
        .attr("width", this.svgNodeCorrel.width)
        .attr("height", this.svgNodeCorrel.height);
      // === line area
      this.D3ChartCorrel.linesArea(
        this.svgNodeCorrel,
        this.filteredData,
        colorExpo(this.colorTheme),
        "rgba(0,0,0,0)",
        2,
        colorExpoAlpha(this.colorTheme),
        "corr",
        "zero",
        false,
        0.5,
        false,
        true,
        "upperLineCorrel",
        "lowerLineCorrel",
        "areaCorrel",
        this.chartBodyCorrel,
      );
    },
    createHoverFX() {
      if (this.svgNode.height === 0 || this.svgNode.width === 0) {
        return;
      }
      let isTwoAx =
        this.selectedMethod === 2 ||
        this.selectedMethod === 3 ||
        this.selectedMethod === 4;
      let isTwoSeries = this.selectedMethod !== 5 && this.selectedMethod !== 6;
      ComparisonCorrelHover(this, isTwoAx, isTwoSeries, this.colorTheme);
      ComparisonSpreadHover(this, isTwoAx, isTwoSeries, this.colorTheme);
      ComparisonHover(this, isTwoAx, isTwoSeries, this.colorTheme);
    },
    getMinMaxYAxis() {
      let minMaxYAxis = [0, 1];
      let minMaxYAxis2 = [0, 1];
      if (this.selectedMethod === 0) {
        // SAME AXIS
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "close",
          "close",
        );
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "close2",
          "close2",
          minMaxYAxis,
        );
      } else if (this.selectedMethod === 1) {
        // BASE 100
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "close_100",
          "close_100",
        );
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "close2_100",
          "close2_100",
          minMaxYAxis,
        );
      } else if (this.selectedMethod === 2 || this.selectedMethod === 4) {
        // TWO AXES or TWO AXES (INV)
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "close",
          "close",
        );
        minMaxYAxis2 = this.processData.minMax(
          this.filteredData,
          "close2",
          "close2",
        );
      } else if (this.selectedMethod === 3) {
        // TWO AXES (LOG)
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "lnClose",
          "lnClose",
        );
        minMaxYAxis2 = this.processData.minMax(
          this.filteredData,
          "lnClose2",
          "lnClose2",
        );
      } else if (this.selectedMethod === 5) {
        // TIMES
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "mult",
          "mult",
        );
      } else if (this.selectedMethod === 6) {
        // DIVIDE
        minMaxYAxis = this.processData.minMax(this.filteredData, "div", "div");
      } else if (this.selectedMethod === 7) {
        // REGRESS
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "close",
          "close",
        );
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "reg",
          "reg",
          minMaxYAxis,
        );
      } else if (this.selectedMethod === 8) {
        // REGRESS (LOG)
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "lnClose",
          "lnClose",
        );
        minMaxYAxis = this.processData.minMax(
          this.filteredData,
          "lnReg",
          "lnReg",
          minMaxYAxis,
        );
      }
      minMaxYAxis = additionalYSpace(minMaxYAxis, 0.1);
      minMaxYAxis2 = additionalYSpace(minMaxYAxis2, 0.1);
      return [minMaxYAxis[0], minMaxYAxis[1], minMaxYAxis2[0], minMaxYAxis2[1]];
    },
    onPickedComparison() {
      this.keepDateInterval = true;
      this.createUpperChart();
      this.createMiddleChart();
      this.createLowerChart();
      this.createHoverFX();
    },
    getComparisonData() {
      this.histAsset = [];
      this.showLoading = true;
      this.showLoadingDataPrep = true;
      this.emitComparisonSelection();
      if (this.selectedAssetType === 0) {
        // 0: CURRENCY
        this.currencyNumber = this.currencySpecs[
          this.selectedAsset0
        ].pk_i_idcurrency;
        this.comparedAsset = this.currencySpecs[
          this.selectedAsset0
        ].currency_name;
        this.comparedAsset =
          this.comparedAsset.slice(0, 3) + "/" + this.comparedAsset.slice(3, 6);
        this.comparedAssetLong = this.comparedAsset;
        let _this = this;
        getCandleData(this)
          .then((data) => {
            this["histAsset"] = this.processData.includeSpot(data, this.spot);
            this["showLoading"] = false;
          })
          .catch(function(error) {
            _this["showLoading"] = false;
            _this["histAsset"] = [];
            console.error(error);
          });
      } else if (this.selectedAssetType === 1) {
        // 1: COMMODITY
        this.comparedAsset = this.commoditySpecs[
          this.selectedAsset1
        ].fk_idproduct.toUpperCase();
        this.comparedAssetLong =
          this.comparedAsset +
          " CONTRACT # " +
          this.commoditySpecs[this.selectedAsset1].selected_contract +
          " (" +
          (this.commoditySpecs[this.selectedAsset1].is_cents
            ? "USc"
            : this.commoditySpecs[this.selectedAsset1].fk_idcurrency) +
          "/" +
          this.commoditySpecs[this.selectedAsset1].fk_idunit +
          ")";
        let _this = this;
        this.commodityNumber = this.commoditySpecs[
          this.selectedAsset1
        ].pk_idcommodity;
        this.commodityContract = this.commoditySpecs[
          this.selectedAsset1
        ].selected_contract;
        getCandleData(this, "commodity", {
          commodityNumber: this.commoditySpecs[this.selectedAsset1]
            .pk_idcommodity,
          contract: this.commoditySpecs[this.selectedAsset1].selected_contract,
        })
          .then((data) => {
            this["histAsset"] = this.processData.includeSpot(data, this.spot);
            this["showLoading"] = false;
          })
          .catch(function(error) {
            _this["showLoading"] = false;
            _this["histAsset"] = [];
            console.error(error);
          });
      } else if (this.selectedAssetType === 2) {
        // 2: INTEREST RATE
        this.irAvailableTerms = [{ label: "...", value: "..." }];
        this.irSelectedTerm = "...";
        this.irHistAllTerms = [];
        this.comparedAsset = this.irSpecs[
          this.selectedAsset2
        ].interest_rate_name.toUpperCase();
        this.comparedAssetLong = this.irSpecs[
          this.selectedAsset2
        ].long_name.toUpperCase();
        let _this = this;
        getCandleData(this, "interest_rate", {
          interest_rate: this.irSpecs[this.selectedAsset2].pk_idinterestrate,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            this.irAvailableTerms = [...new Set(data.map((item) => item.term))]
              .filter((d) => d !== null)
              .map((item) => ({ label: item, value: item }));
            if (
              this.irAvailableTerms.filter((d) => d.value === "3M").length > 0
            ) {
              this.irSelectedTerm = "3M";
            } else if (
              this.irAvailableTerms.filter((d) => d.value === "10Y").length > 0
            ) {
              this.irSelectedTerm = "10Y";
            } else {
              this.irSelectedTerm = this.irAvailableTerms[0].value;
            }
            this.irHistAllTerms = data;
            if (this.irAvailableTerms.length > 1) {
              this.histAsset = this.irHistAllTerms.filter(
                (d) => d.term === _this.irSelectedTerm,
              );
            } else {
              this.histAsset = data;
            }
            this.histAsset = this.processData.includeSpot(
              this.histAsset,
              this.spot,
            );
            this["showLoading"] = false;
          })
          .catch(function(error) {
            _this["showLoading"] = false;
            _this["histAsset"] = [];
            console.error(error);
          });
      } else if (this.selectedAssetType === 3) {
        // 3: INDEX
        this.comparedAsset = this.indexSpecs[
          this.selectedAsset3
        ].short_name.toUpperCase();
        this.comparedAssetLong = this.indexSpecs[
          this.selectedAsset3
        ].long_name.toUpperCase();
        let _this = this;
        getCandleData(this, "index", {
          index: this.indexSpecs[this.selectedAsset3].pk_i_idindexes,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            this.histAsset = this.processData.includeSpot(data, this.spot);
            this["showLoading"] = false;
          })
          .catch(function(error) {
            _this["showLoading"] = false;
            _this["histAsset"] = [];
            console.error(error);
          });
      } else if (this.selectedAssetType === 4) {
        // 4: FUTURES
        this.comparedAsset = this.futuresSpecs[
          this.selectedAsset4
        ].short_name.toUpperCase();
        this.comparedAssetLong = this.futuresSpecs[
          this.selectedAsset4
        ].long_name.toUpperCase();
        let _this = this;
        getCandleData(this, "futures", {
          futures: this.futuresSpecs[this.selectedAsset4].pk_i_idfutures,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            this.histAsset = this.processData.includeSpot(data, this.spot);
            this["showLoading"] = false;
          })
          .catch(function(error) {
            _this["showLoading"] = false;
            _this["histAsset"] = [];
            console.error(error);
          });
      } else if (this.selectedAssetType === 5) {
        // 5: ETF
        this.comparedAsset = this.etfSpecs[
          this.selectedAsset5
        ].short_name.toUpperCase();
        this.comparedAssetLong = this.etfSpecs[
          this.selectedAsset5
        ].long_name.toUpperCase();
        let _this = this;
        getCandleData(this, "etfs", {
          etfs: this.etfSpecs[this.selectedAsset5].pk_i_idetf,
          initDate: this.initCurrencyDate,
        })
          .then((data) => {
            this.histAsset = this.processData.includeSpot(data, this.spot);
            this["showLoading"] = false;
          })
          .catch(function(error) {
            _this["showLoading"] = false;
            _this["histAsset"] = [];
            console.error(error);
          });
      }
      this.showFetch = false;
    },
    // Splitter
    onContext(context) {
      this.context = context;
    },
    onResizePanel(value) {
      this.panels = value.panels;
      if (this.onChangeScenarios) {
        this.sizeSplitters({ isRestore: true });
      } else {
        this.sizeSplitters({});
      }
      this.onChangeScenarios = false;
    },
    onRestoreSizes() {
      this.sizeSplitters({ isRestore: true });
    },
    sizeSplitters({ isRestore = false }) {
      this.panels.forEach((panel) => {
        const el = panel.$el.className;
        const selectElement = select(`.${el.split(" ").join(".")}`);
        if (isRestore) {
          selectElement
            .style("height", `${panel.size}%`)
            .style(
              "flex-basis",
              `calc(${panel.size}% - ${(this.panels.length - 1) *
                this.context.gutterSize}px)`,
            );
        } else {
          selectElement.style("overflow", "hidden");
        }
      });
      this.$emit("resizeCharts");
    },
    getClassChartQty() {
      this.chartSizes.sizeSplitterChartPrices = 61;
      this.chartSizes.sizeSplitterChart = 19;
      this.chartSizes.sizeSplitterChartCorr = 19;
      return "quantity_height";
    },
    handleSplitterSizeChange() {
      this.$emit("resizeCharts");
    },
    onUserRestoreSizes() {
      this.$emit("eventOnUserRestoreSizes");
    },
    // ===== URL/route selection sync =====
    comparisonTypeSlug() {
      return COMPARISON_TYPE_SLUGS[this.selectedAssetType] || null;
    },
    comparisonAssetSlug() {
      try {
        switch (this.selectedAssetType) {
          case 0:
            return slugifyProductItem(
              this.currencySpecs[this.selectedAsset0].currency_name,
            );
          case 1:
            return slugifyProductItem(
              this.commoditySpecs[this.selectedAsset1].fk_idproduct,
            );
          case 2:
            return slugifyProductItem(
              this.irSpecs[this.selectedAsset2].interest_rate_name,
            );
          case 3:
            return slugifyProductItem(
              this.indexSpecs[this.selectedAsset3].short_name,
            );
          case 4:
            return slugifyProductItem(
              this.futuresSpecs[this.selectedAsset4].short_name,
            );
          case 5:
            return slugifyProductItem(
              this.etfSpecs[this.selectedAsset5].short_name,
            );
          default:
            return null;
        }
      } catch (error) {
        return null;
      }
    },
    emitComparisonSelection() {
      const type = this.comparisonTypeSlug();
      const asset = this.comparisonAssetSlug();
      this.lastCommittedType = type;
      this.lastCommittedAsset = asset;
      this.$emit("onComparisonSelection", { type, asset });
    },
    applyInitialComparison() {
      const typeIndex = COMPARISON_TYPE_SLUGS.indexOf(this.initCompareType);
      if (typeIndex < 0) return;
      this.selectedAssetType = typeIndex;
      const slug = this.initCompareAsset;
      if (!slug) return;
      const findBySlug = (specs, key) =>
        Array.isArray(specs)
          ? specs.findIndex((d) => slugifyProductItem(d[key]) === slug)
          : -1;
      let idx = -1;
      switch (typeIndex) {
        case 0:
          idx = findBySlug(this.currencySpecs, "currency_name");
          if (idx >= 0) this.selectedAsset0 = idx;
          break;
        case 1:
          idx = findBySlug(this.commoditySpecs, "fk_idproduct");
          if (idx >= 0) this.selectedAsset1 = idx;
          break;
        case 2:
          idx = findBySlug(this.irSpecs, "interest_rate_name");
          if (idx >= 0) this.selectedAsset2 = idx;
          break;
        case 3:
          idx = findBySlug(this.indexSpecs, "short_name");
          if (idx >= 0) this.selectedAsset3 = idx;
          break;
        case 4:
          idx = findBySlug(this.futuresSpecs, "short_name");
          if (idx >= 0) this.selectedAsset4 = idx;
          break;
        case 5:
          idx = findBySlug(this.etfSpecs, "short_name");
          if (idx >= 0) this.selectedAsset5 = idx;
          break;
      }
    },
    onSelectedAssetType() {
      this.multiply = 1;
      this.showFetch = true;
    },
    onUserAssetSelection() {
      this.multiply = 1;
      this.showFetch = true;
    },
    onChangeDWM(item) {
      this.pickedDateInterval =
        item === "day" ? "1Y" : item === "week" ? "3Y" : "5Y";
      this.interval = item;
      this.dateFormat = this.tFormat[item];
      this.dateTitle = this.prefixOptions[item];
      this.title = this.titleTexts[item];
    },
    onUserNCorrelChange() {
      this.addRollingCorrelation();
      this.sliceMethod();
      this.showLoadingDataPrep = false;
      this.createUpperChart();
      this.createMiddleChart();
      this.createLowerChart();
      this.createHoverFX();
    },
    onChangeTerm(item) {
      let _this = this;
      this.irSelectedTerm = item;
      if (this.irAvailableTerms.length > 1) {
        this.histAsset = this.irHistAllTerms.filter(
          (d) => d.term === _this.irSelectedTerm,
        );
      }
      this.dataAndCharts();
      this.showLoadingDataPrep = false;
    },
    onChangeConversion(item) {
      this.onUserMultiply(+this.conversionByCmdty[item.value]);
    },
    // ===== Changing time intervals  =====
    onChangeInterval(item) {
      this.showLoadingDataPrep = true;
      this.pickedDateInterval = item;
      this.sliceMethod();
      this.showLoadingDataPrep = false;
      this.createUpperChart();
      this.createMiddleChart();
      this.createLowerChart();
      this.createHoverFX();
    },
    callWidth() {
      if (this.histAsset.length > 0) {
        this.createUpperChart();
        this.createMiddleChart();
        this.createLowerChart();
        this.createHoverFX();
      }
    },
  },
};
</script>

<style>
.comparison-container {
  position: relative;
}
.fetch-overlay {
  position: absolute;
  inset: 0; /* top:0 right:0 bottom:0 left:0 */
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--background-alpha2);
  backdrop-filter: blur(1px); /* opcional */
  z-index: 100;
}

.controls-labels.row.f-row.txt-label-primary-2 {
  vertical-align: middle !important;
  padding: 0 65px 0 65px !important;
}
.mouse-pointer {
  position: absolute;
  left: 7px;
  color: var(--textactive);
}
.container-conversion div.p-dropdown-trigger > span {
  display: none;
}
.container-chart-comp {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
}
.container-legends-comp {
  position: absolute;
  top: 5px;
  left: 75px;
}
.p-splitter {
  border: 0;
  background: 0;
  border-radius: 0;
  color: transparent;
}
div.p-splitter .p-splitter-gutter {
  background: 0;
}
.container_table {
  height: 100%;
}
.container_charts > .p-splitter {
  min-height: 80vh;
}
.container_charts {
  height: calc(100vh - 155px);
  flex-direction: column;
  width: 100%;
  align-items: center;
}
.container_chart_prices,
.container_chart_quantity {
  height: calc(100% - 22px);
}
.container-comp-title {
  font-size: 0.9rem;
}
@media (max-width: 1150px) {
  .controls-labels.row.f-row.txt-label-primary-2 {
    padding: 0 5px !important;
    white-space: nowrap;
  }
  .container-comp-title {
    font-size: 0.8rem;
  }
  .container_charts > .p-splitter {
    min-height: 75vh;
  }
}
/* @media (min-width: 1440px) {
  .container-legends-comp {
    top: 5%;
    left: 4%;
  }
} */
</style>
